// extracted by mini-css-extract-plugin
export default {"spacing":"Spacing_spacing__ksBwi","vertical":"Spacing_vertical__ysv4Q","horizontal":"Spacing_horizontal__lnHPs"};